import moment from "moment";
import { SalesState as State } from "./sales.types";
import { SetTicketInOrderAction } from "./sales.types";
import { SalesActions as Actions } from "./sales.types";
import { SetStoresAction } from "./sales.types";
import { RESET_SALES_INIT_ORDER, SET_SEARCH_STORES } from "./sales.actions";
import { SET_SELECTED_CART_ITEM_ID } from "./sales.actions";
import { SET_VENDORS } from "./sales.actions";
import { SET_LAST_ORDER_TICKETS, SET_TICKET_IN_ORDER } from "./sales.actions";
import { RESET_SALES_AFTER_ORDER } from "./sales.actions";
import { SET_SELECTED_VENDOR_ID } from "./sales.actions";
import { SET_SALES_PROCESS } from "./sales.actions";
import { SET_STORES } from "./sales.actions";
import { SET_SHOPPING_CART, RESET_SHOPPING_CART } from "./sales.actions";
import { SET_SELECTED_PAYMENT_METHOD_ID } from "./sales.actions";
import { SET_PAYMENT_METHODS } from "./sales.actions";
import { SET_SELECTED_PRODUCT_ID } from "./sales.actions";
import { SET_SELECTED_CATEGORY_ID } from "./sales.actions";
import { RESET_SALES, RESET_STORES, SET_ACCOUNT } from "./sales.actions";
import { SET_SELECTED_STORE_ID, SET_CHANNELS } from "./sales.actions";
import { SET_SELECTED_CHANNEL_ID, SET_LAST_ORDER } from "./sales.actions";
import { getInitialPaginationData } from "util/pagination";
import { findPaymentMethodById, stateInitOrder } from "./sales.reducer.helpers";
import { findChannelById } from "./sales.reducer.helpers";
import { setPage } from "util/redux.utils";
import { SET_RECOMMENDED_PRODUCT } from "./sales.actions";
import { SET_PAYMENT_INSCRIPTIONS } from "./sales.actions";
import { SET_SELECTED_DATE_RANGE } from "./sales.actions";
import { buildInitialShoppingCart } from "util/testUtils/builders/sales/shoppingCart.builder";
import { stateAfterOrder, salesStateLogout } from "./sales.reducer.helpers";
import { findVendorById } from "./sales.reducer.helpers";

const initialState: State = {
  account: undefined,
  channels: undefined,
  selectedChannel: findChannelById,
  vendors: undefined,
  salesProcess: undefined,
  selectedChannelId: undefined,
  selectedVendorId: undefined,
  selectedVendor: findVendorById,
  selectedDateRange: [moment().subtract(1, "week"), moment()],
  stores: getInitialPaginationData(),
  searchStores: getInitialPaginationData(),
  selectedStoreId: undefined,
  selectedCategoryId: undefined,
  selectedProductId: undefined,
  shoppingCart: buildInitialShoppingCart(),
  recommendedProduct: undefined,
  paymentMethods: undefined,
  selectedPaymentMethodId: undefined,
  selectedPaymentMethod: findPaymentMethodById,
  selectedCartItemId: undefined,
  lastOrder: undefined,
  lastOrderTickets: undefined,
  paymentInscriptions: undefined
};

const reducer = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case SET_ACCOUNT:
      return { ...state, account: action.payload };
    case SET_SALES_PROCESS:
      return { ...state, salesProcess: action.payload };
    case SET_CHANNELS:
      return { ...state, channels: action.payload };
    case SET_VENDORS:
      return { ...state, vendors: action.payload };
    case SET_SELECTED_CHANNEL_ID:
      return { ...state, selectedChannelId: action.payload };
    case SET_SELECTED_VENDOR_ID:
      return { ...state, selectedVendorId: action.payload };
    case SET_STORES:
      return setStores(state, action.payload);
    case SET_SEARCH_STORES:
      return setSearchStores(state, action.payload);
    case SET_SELECTED_STORE_ID:
      return { ...state, selectedStoreId: action.payload };
    case SET_SELECTED_CATEGORY_ID:
      return { ...state, selectedCategoryId: action.payload };
    case SET_PAYMENT_METHODS:
      return { ...state, paymentMethods: action.payload };
    case SET_SELECTED_PAYMENT_METHOD_ID:
      return { ...state, selectedPaymentMethodId: action.payload };
    case SET_SELECTED_PRODUCT_ID:
      return { ...state, selectedProductId: action.payload };
    case RESET_STORES:
      return { ...state, stores: getInitialPaginationData() };
    case SET_RECOMMENDED_PRODUCT:
      return { ...state, recommendedProduct: action.payload };
    case SET_LAST_ORDER:
      return { ...state, lastOrder: action.payload };
    case SET_SHOPPING_CART:
      return { ...state, shoppingCart: action.payload };
    case SET_SELECTED_CART_ITEM_ID:
      return { ...state, selectedCartItemId: action.payload };
    case SET_LAST_ORDER_TICKETS:
      return { ...state, lastOrderTickets: action.payload };
    case SET_TICKET_IN_ORDER:
      return setNewTicket(state, action.payload);
    case RESET_SHOPPING_CART:
      return { ...state, shoppingCart: buildInitialShoppingCart() };
    case RESET_SALES_AFTER_ORDER:
      return resetSalesAfterOrder(state);
    case RESET_SALES_INIT_ORDER:
      return resetSalesInitOrder(state);
    case RESET_SALES:
      return resetSales();
    case SET_PAYMENT_INSCRIPTIONS:
      return { ...state, paymentInscriptions: action.payload };
    case SET_SELECTED_DATE_RANGE:
      return { ...state, selectedDateRange: action.payload };
    default:
      return state;
  }
};

const setStores = (
  state: State,
  payload: SetStoresAction["payload"]
): State => {
  const newStores = setPage(state.stores, payload);
  return { ...state, stores: newStores };
};

const setSearchStores = (
  state: State,
  payload: SetStoresAction["payload"]
): State => {
  const newStores = setPage(state.searchStores, payload);
  return { ...state, searchStores: newStores };
};

const setNewTicket = (
  state: State,
  payload: SetTicketInOrderAction["payload"]
): State => {
  const { lastOrderTickets = [] } = state;
  const newLastOrderTickets = [payload, ...lastOrderTickets];
  return { ...state, lastOrderTickets: newLastOrderTickets };
};

const resetSalesInitOrder = (state: State): State => {
  return {
    ...state,
    ...stateInitOrder
  };
};

const resetSalesAfterOrder = (state: State): State => {
  return {
    ...state,
    ...stateAfterOrder
  };
};

const resetSales = (): State => {
  return salesStateLogout;
};

export default reducer;
